import restClient from "../restClient";

export const getDocuments = async (type = "") => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`/documenties?document_type=${type}&populate=*`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const createDocument = async (data, files) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    };

    const formData = new FormData();

    // Add data to formData
    if (data) {
      formData.append('data', JSON.stringify(data));
    }

    // Add files to formData
    if (files && files.document) {
      formData.append('files.document', files.document);
    }

    const response = await restClient.post("/documenties", formData, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const updateDocument = async (id, data, files) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': files ? 'multipart/form-data' : 'application/json',
      },
    };

    // If files exist, use FormData
    if (files && files.document) {
      const formData = new FormData();
      if (data) {
        formData.append('data', JSON.stringify(data));
      }
      formData.append('files.document', files.document);
      const response = await restClient.put(`/documenties/${id}`, formData, config);
      return response.data;
    } else {
      // No files, use regular JSON
      const response = await restClient.put(`/documenties/${id}`, { data }, config);
      return response.data;
    }
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const deleteDocument = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`/documenties/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
